import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/cultural-platform.css';

// Arts Gallery Data - 30 images with global diversity
const artsGalleryData = [
  // USA & Americas
  {
    url: 'https://images.unsplash.com/photo-1762091409592-ed6d0dfed0ba',
    title: 'Statue of Liberty',
    caption: 'America\'s iconic symbol of freedom and democracy, welcoming millions to New York Harbor since 1886',
    region: 'USA'
  },
  {
    url: 'https://images.unsplash.com/photo-1705848534174-36c90beb9da2',
    title: 'Library of Congress',
    caption: 'The magnificent Thomas Jefferson Building - America\'s oldest cultural institution and largest library in the world',
    region: 'USA'
  },
  {
    url: 'https://images.unsplash.com/photo-1768101962310-d781f7942287',
    title: 'Day of the Dead Art',
    caption: 'Mexico\'s vibrant Día de los Muertos tradition - colorful sugar skulls honoring ancestors',
    region: 'Mexico'
  },
  // Europe
  {
    url: 'https://images.unsplash.com/photo-1743364971078-53fd19ea1033',
    title: 'Eiffel Tower Paris',
    caption: 'France\'s iconic iron lattice tower - symbol of Parisian art and engineering excellence since 1889',
    region: 'France'
  },
  {
    url: 'https://images.unsplash.com/photo-1762766768563-7a10e34231e7',
    title: 'The Louvre Museum',
    caption: 'World\'s largest art museum housing over 35,000 masterpieces including the Mona Lisa in Paris',
    region: 'France'
  },
  {
    url: 'https://images.unsplash.com/photo-1690122582259-d3e7b2cde7ec',
    title: 'European Art Gallery',
    caption: 'Classic museum corridor showcasing centuries of European artistic heritage and masterpieces',
    region: 'Europe'
  },
  {
    url: 'https://images.unsplash.com/photo-1628103343862-4ab1cb900224',
    title: 'Michelangelo\'s David',
    caption: 'Renaissance masterpiece sculpted 1501-1504 - symbol of human artistic achievement in Florence, Italy',
    region: 'Italy'
  },
  {
    url: 'https://images.unsplash.com/photo-1709497186727-753a50ec883e',
    title: 'Vatican Sculpture',
    caption: 'Baroque masterpiece in Vatican City - religious art representing centuries of Catholic heritage',
    region: 'Vatican'
  },
  {
    url: 'https://images.unsplash.com/photo-1583748969877-76af108e461d',
    title: 'Royal Academy of Arts',
    caption: 'London\'s prestigious art institution founded in 1768 - home to British artistic excellence',
    region: 'UK'
  },
  // India
  {
    url: 'https://images.unsplash.com/photo-1591018603054-32d12cb075a1',
    title: 'Taj Mahal',
    caption: 'India\'s crown jewel of Mughal architecture - UNESCO World Heritage Site and symbol of eternal love',
    region: 'India'
  },
  {
    url: 'https://images.unsplash.com/photo-1523980145253-50327d891e0e',
    title: 'Taj Mahal Reflection',
    caption: 'The white marble mausoleum in Agra - one of the Seven Wonders of the Modern World',
    region: 'India'
  },
  // Southeast Asia
  {
    url: 'https://images.unsplash.com/photo-1646828697863-4db40583627d',
    title: 'Marina Bay Sands Singapore',
    caption: 'Singapore\'s iconic architectural marvel - symbol of modern Asian prosperity and innovation',
    region: 'Singapore'
  },
  {
    url: 'https://images.unsplash.com/photo-1763436348752-27044b850cb9',
    title: 'Borobudur Temple',
    caption: 'Indonesia\'s 9th-century Buddhist temple - world\'s largest Buddhist monument with 2,672 relief panels',
    region: 'Indonesia'
  },
  {
    url: 'https://images.unsplash.com/photo-1593537898540-b8b821014c8e',
    title: 'Borobudur Buddha',
    caption: 'Ancient Buddha statues at Borobudur - masterpiece of Indonesian Buddhist architecture',
    region: 'Indonesia'
  },
  {
    url: 'https://images.unsplash.com/photo-1692014617270-e3d2ab563ed1',
    title: 'Petronas Towers View',
    caption: 'Malaysia\'s twin towers - Islamic-inspired postmodern architecture and national pride',
    region: 'Malaysia'
  },
  {
    url: 'https://images.unsplash.com/photo-1764753318028-a0151ca009fa',
    title: 'Grand Palace Bangkok',
    caption: 'Thailand\'s stunning royal complex with intricate golden spires and Buddhist architecture',
    region: 'Thailand'
  },
  // East Asia
  {
    url: 'https://images.unsplash.com/photo-1705885937367-afdcd5e8e201',
    title: 'Chinese Dragon Lantern',
    caption: 'Traditional Chinese dragon lantern - symbol of power, strength, and good fortune',
    region: 'China'
  },
  {
    url: 'https://images.unsplash.com/photo-1705885937170-a40324725714',
    title: 'Chinese Festival Art',
    caption: 'Colorful dragon statues celebrating Chinese Lunar New Year traditions',
    region: 'China'
  },
  // Africa
  {
    url: 'https://images.unsplash.com/photo-1701974833000-7492605b2112',
    title: 'African Traditional Art',
    caption: 'Vibrant African ceremonial costumes - rich heritage of Sub-Saharan artistic traditions',
    region: 'Africa'
  },
  {
    url: 'https://images.unsplash.com/photo-1746913507404-72ec3a8b20a2',
    title: 'Religious Stone Carvings',
    caption: 'Elaborate stone carvings depicting religious scenes - African sculptural heritage',
    region: 'Africa'
  },
  // South America
  {
    url: 'https://images.unsplash.com/photo-1583166614297-a97b68d5cead',
    title: 'Capoeira Brazil',
    caption: 'Brazilian martial art combining dance, acrobatics, and music - UNESCO Intangible Cultural Heritage',
    region: 'Brazil'
  },
  // Middle East (Secondary)
  {
    url: 'https://images.unsplash.com/photo-1692191536442-bd4a66c5e9db',
    title: 'Sheikh Zayed Grand Mosque',
    caption: 'Abu Dhabi\'s architectural masterpiece - one of the world\'s largest mosques featuring 82 domes',
    region: 'UAE'
  },
  {
    url: 'https://images.unsplash.com/photo-1678038592327-c5730737f867',
    title: 'Pyramids of Giza',
    caption: 'Egypt\'s ancient wonders - the last surviving monument of the Seven Wonders of the Ancient World',
    region: 'Egypt'
  },
  {
    url: 'https://images.unsplash.com/photo-1584183812211-df586f1fb0da',
    title: 'Riyadh Mosque',
    caption: 'Traditional Saudi Arabian mosque architecture representing Islamic artistic heritage',
    region: 'Saudi Arabia'
  },
  {
    url: 'https://images.unsplash.com/photo-1667935175008-397be1e777b9',
    title: 'Ancient Jerash',
    caption: 'Jordan\'s remarkably preserved Roman city - 2nd century AD columns and theaters',
    region: 'Jordan'
  },
  {
    url: 'https://images.unsplash.com/photo-1761475457984-1a4f6c272368',
    title: 'Islamic Tilework',
    caption: 'Intricate Islamic geometric patterns and Arabic calligraphy - Middle Eastern artistic mastery',
    region: 'Middle East'
  },
  // Additional Global
  {
    url: 'https://images.unsplash.com/photo-1740299697868-07af995b3ef8',
    title: 'Museum Sculpture Hall',
    caption: 'Classical sculpture gallery showcasing millennia of human artistic achievement',
    region: 'Global'
  },
  {
    url: 'https://images.unsplash.com/photo-1631340729644-8b8aad1e9dba',
    title: 'Balinese Temple',
    caption: 'Indonesia\'s ornate Hindu temple architecture - spiritual art of Bali',
    region: 'Indonesia'
  },
  {
    url: 'https://images.unsplash.com/photo-1727685991887-3255c5e2a2b0',
    title: 'Indian Architecture',
    caption: 'Magnificent Indian palatial architecture showcasing Mughal and Rajasthani design',
    region: 'India'
  },
  {
    url: 'https://images.unsplash.com/photo-1759850344167-4258cdd1f4d9',
    title: 'Singapore Skyline',
    caption: 'Modern Singapore\'s spectacular rooftop gardens and innovative architecture',
    region: 'Singapore'
  }
];

// Films Gallery Data - 30 images with global diversity
const filmsGalleryData = [
  // Hollywood & USA
  {
    url: 'https://images.unsplash.com/photo-1574771343329-f6f08f96d3da',
    title: 'Statue of Liberty Cinema',
    caption: 'American cinema\'s enduring symbol of freedom and the Hollywood dream',
    region: 'USA'
  },
  {
    url: 'https://images.unsplash.com/photo-1578674473215-9e07ee2e577d',
    title: 'Hollywood Sign',
    caption: 'The iconic landmark representing over a century of American film industry excellence',
    region: 'USA'
  },
  {
    url: 'https://images.unsplash.com/photo-1764581659101-0c2a38ebe301',
    title: 'Hollywood Clapperboard',
    caption: 'The universal symbol of cinema representing creative storytelling worldwide',
    region: 'Global'
  },
  // European Cinema
  {
    url: 'https://images.unsplash.com/photo-1743364971200-aadac6cb762d',
    title: 'Paris Film Location',
    caption: 'The City of Light - inspiration for countless romantic films and French cinema classics',
    region: 'France'
  },
  {
    url: 'https://images.unsplash.com/photo-1651764915167-6736b20968e0',
    title: 'European Film Archive',
    caption: 'Historic European film archives preserving cinema heritage from the silent era',
    region: 'Europe'
  },
  {
    url: 'https://images.unsplash.com/photo-1755039466834-3322b29dc45e',
    title: 'Film Awards Trophies',
    caption: 'Golden trophies honoring excellence in international filmmaking',
    region: 'Global'
  },
  // Indian Cinema - Bollywood
  {
    url: 'https://images.unsplash.com/photo-1765854895912-ff00fe2c5b0a',
    title: 'Bollywood Colors',
    caption: 'India\'s vibrant Bollywood industry - world\'s largest film producer by number of films',
    region: 'India'
  },
  {
    url: 'https://images.unsplash.com/photo-1602045627378-4581cfbd0018',
    title: 'Indian Cinema Culture',
    caption: 'Colorful Indian film traditions blending music, dance, and dramatic storytelling',
    region: 'India'
  },
  {
    url: 'https://images.unsplash.com/photo-1668011195117-27a60092a629',
    title: 'South Asian Film',
    caption: 'Regional Indian cinema showcasing diverse languages and cultural narratives',
    region: 'India'
  },
  // Southeast Asian Cinema
  {
    url: 'https://images.unsplash.com/photo-1671885887087-f35318298cb4',
    title: 'Singapore Film Scene',
    caption: 'Singapore\'s emerging film industry - Southeast Asian cinematic hub',
    region: 'Singapore'
  },
  {
    url: 'https://images.unsplash.com/photo-1679323993535-2e76ad15ca65',
    title: 'Indonesian Film Locations',
    caption: 'Indonesia\'s stunning landscapes featured in international film productions',
    region: 'Indonesia'
  },
  {
    url: 'https://images.unsplash.com/photo-1694378257898-b75755b8b39e',
    title: 'Malaysian Cinema',
    caption: 'Malaysia\'s growing film industry showcasing multicultural storytelling',
    region: 'Malaysia'
  },
  {
    url: 'https://images.unsplash.com/photo-1759770273833-45ee906c7219',
    title: 'Thai Film Industry',
    caption: 'Thailand\'s Buddhist temples featured in international film productions',
    region: 'Thailand'
  },
  // East Asian Cinema
  {
    url: 'https://images.unsplash.com/photo-1767710039823-df02b80d624f',
    title: 'Chinese Cinema Festival',
    caption: 'China\'s rich film heritage - from Fifth Generation masters to modern blockbusters',
    region: 'China'
  },
  {
    url: 'https://images.unsplash.com/photo-1705885937419-4b8be7c54543',
    title: 'Asian Film Tradition',
    caption: 'East Asian cinema\'s unique visual storytelling and cultural narratives',
    region: 'Asia'
  },
  // African Cinema
  {
    url: 'https://images.unsplash.com/photo-1722481744477-d0b0bb2bbba2',
    title: 'Nollywood Nigeria',
    caption: 'Nigeria\'s Nollywood - world\'s second largest film industry by volume',
    region: 'Africa'
  },
  {
    url: 'https://images.unsplash.com/photo-1660675134044-6f1990caba94',
    title: 'African Dance on Film',
    caption: 'African cultural performances captured in documentary and narrative cinema',
    region: 'Africa'
  },
  // Latin American Cinema
  {
    url: 'https://images.unsplash.com/photo-1710987584061-562ba3df7bb6',
    title: 'Brazilian Street Theater',
    caption: 'Brazil\'s vibrant street performance culture inspiring Cinema Novo movement',
    region: 'Brazil'
  },
  {
    url: 'https://images.unsplash.com/photo-1742276399767-6a346935152d',
    title: 'Mexican Cinema',
    caption: 'Mexico\'s Golden Age cinema tradition continuing with modern Oscar winners',
    region: 'Mexico'
  },
  // Production & Equipment
  {
    url: 'https://images.unsplash.com/photo-1550178683-4529beff6c08',
    title: 'Film Production Crew',
    caption: 'Behind-the-scenes of international film production capturing stories',
    region: 'Global'
  },
  {
    url: 'https://images.unsplash.com/photo-1637441210953-5d99e6d6c37e',
    title: 'Cinematography Team',
    caption: 'Professional crew working together to capture cinematic excellence',
    region: 'Global'
  },
  {
    url: 'https://images.unsplash.com/photo-1517604931442-7e0c8ed2963c',
    title: 'Classic Cinema Interior',
    caption: 'Vintage movie theater interior preserving the magic of cinema heritage',
    region: 'Global'
  },
  {
    url: 'https://images.unsplash.com/photo-1485846234645-a62644f84728',
    title: 'Documentary Filmmaking',
    caption: 'Documentary film production capturing real stories from around the world',
    region: 'Global'
  },
  {
    url: 'https://images.unsplash.com/photo-1536440136628-849c177e76a1',
    title: 'World Cinema',
    caption: 'International cinema celebrating diverse storytelling traditions',
    region: 'Global'
  },
  // Middle East Cinema (Secondary)
  {
    url: 'https://images.unsplash.com/photo-1737007211202-fbd5d9d79681',
    title: 'UAE Film Production',
    caption: 'UAE emerging as a global film production hub with world-class studios',
    region: 'UAE'
  },
  {
    url: 'https://images.unsplash.com/photo-1678038592316-8692bf2b0a43',
    title: 'Egyptian Cinema Heritage',
    caption: 'Egypt\'s legendary film industry - the Hollywood of the Arab world since 1927',
    region: 'Egypt'
  },
  {
    url: 'https://images.unsplash.com/photo-1765303314172-4a581ffdd5f7',
    title: 'Saudi Film Renaissance',
    caption: 'Saudi Arabia\'s historic film industry revival and international film festivals',
    region: 'Saudi Arabia'
  },
  {
    url: 'https://images.unsplash.com/photo-1763652065673-4ca9a7339412',
    title: 'Jordan Film Locations',
    caption: 'Jordan\'s landscapes featured in Lawrence of Arabia, The Martian, and more',
    region: 'Jordan'
  },
  // Additional
  {
    url: 'https://images.unsplash.com/photo-1582473764884-c969c3a21aa3',
    title: 'Cinema Neon Sign',
    caption: 'Classic cinema signage representing the golden age of movie theaters',
    region: 'Global'
  },
  {
    url: 'https://images.unsplash.com/photo-1768393483296-249efa2f7ad5',
    title: 'Thai Temple in Film',
    caption: 'Thailand\'s Grand Palace complex - popular filming location for international productions',
    region: 'Thailand'
  }
];

// Culture Gallery Data - 30 images with global diversity
const cultureGalleryData = [
  // USA & Americas
  {
    url: 'https://images.unsplash.com/photo-1618243545619-479e9b5cfacf',
    title: 'American Freedom Symbol',
    caption: 'The Statue of Liberty - welcoming symbol of American cultural values and immigrant heritage',
    region: 'USA'
  },
  {
    url: 'https://images.unsplash.com/photo-1768101962309-19d0be54661b',
    title: 'Día de los Muertos',
    caption: 'Mexico\'s Day of the Dead - UNESCO-recognized tradition honoring ancestors with colorful altars',
    region: 'Mexico'
  },
  {
    url: 'https://images.unsplash.com/photo-1643584872305-9dffde0d7a0f',
    title: 'Mexican Folk Art',
    caption: 'Colorful embroidered skull ornaments - traditional Mexican folk art and craftsmanship',
    region: 'Mexico'
  },
  {
    url: 'https://images.unsplash.com/photo-1735839550903-98b86765a0d2',
    title: 'Brazilian Carnival',
    caption: 'Rio Carnival - world\'s biggest festival celebrating Brazilian culture and samba traditions',
    region: 'Brazil'
  },
  // Europe
  {
    url: 'https://images.unsplash.com/photo-1743364971070-6f269cec688c',
    title: 'Parisian Culture',
    caption: 'Paris - the cultural capital of Europe, home to art, fashion, and culinary excellence',
    region: 'France'
  },
  {
    url: 'https://images.unsplash.com/photo-1743968031075-1e4d70cd487b',
    title: 'European Heritage',
    caption: 'Historic European architecture representing centuries of Western cultural development',
    region: 'Europe'
  },
  // India
  {
    url: 'https://images.unsplash.com/photo-1706191464637-57e9229b6a57',
    title: 'Indian Heritage Site',
    caption: 'India\'s magnificent architectural heritage - blend of Hindu, Islamic, and colonial influences',
    region: 'India'
  },
  {
    url: 'https://images.unsplash.com/photo-1605368504600-f2cca6ea012a',
    title: 'Diwali Festival',
    caption: 'India\'s Festival of Lights - celebrating the victory of light over darkness',
    region: 'India'
  },
  {
    url: 'https://images.unsplash.com/photo-1761125064798-530c13c32b6d',
    title: 'Indian Sari Heritage',
    caption: 'Traditional Indian saris - 5,000-year-old textile tradition in vibrant colors',
    region: 'India'
  },
  // Southeast Asia
  {
    url: 'https://images.unsplash.com/photo-1763532239800-93babe7aaec3',
    title: 'Singapore Night Culture',
    caption: 'Singapore\'s modern multicultural identity - blend of Chinese, Malay, Indian, and Western influences',
    region: 'Singapore'
  },
  {
    url: 'https://images.unsplash.com/photo-1699442108600-1a9e875b1104',
    title: 'Indonesian Headdress',
    caption: 'Elaborate Indonesian ceremonial headdress - Javanese and Balinese royal traditions',
    region: 'Indonesia'
  },
  {
    url: 'https://images.unsplash.com/photo-1692014617309-d14c9f07bbf8',
    title: 'Malaysian Diversity',
    caption: 'Malaysia\'s multicultural heritage - Malay, Chinese, Indian, and indigenous traditions',
    region: 'Malaysia'
  },
  {
    url: 'https://images.unsplash.com/photo-1767772903230-022fffcb205a',
    title: 'Thai Temple Culture',
    caption: 'Thailand\'s Buddhist temple traditions - intricate golden architecture and spiritual practices',
    region: 'Thailand'
  },
  // East Asia
  {
    url: 'https://images.unsplash.com/photo-1767710039823-df02b80d624f',
    title: 'Chinese New Year',
    caption: 'Chinese Lunar New Year - world\'s largest annual human migration and family celebration',
    region: 'China'
  },
  {
    url: 'https://images.unsplash.com/photo-1533669955142-6a73332af4db',
    title: 'Japanese Tea Ceremony',
    caption: 'Japan\'s ancient tea ceremony - spiritual practice of harmony, respect, purity, and tranquility',
    region: 'Japan'
  },
  // Africa
  {
    url: 'https://images.unsplash.com/photo-1722481746744-c6c95b900003',
    title: 'African Festival',
    caption: 'Vibrant African cultural celebrations - music, dance, and community traditions',
    region: 'Africa'
  },
  {
    url: 'https://images.unsplash.com/photo-1701974833000-7492605b2112',
    title: 'African Ceremonial Dress',
    caption: 'Traditional African ceremonial costumes - colorful textiles and cultural identity',
    region: 'Africa'
  },
  {
    url: 'https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e',
    title: 'Moroccan Heritage',
    caption: 'Morocco\'s Islamic geometric patterns - centuries of artistic tradition in architecture',
    region: 'Morocco'
  },
  // South Asia Festivals
  {
    url: 'https://images.unsplash.com/photo-1767330855183-4b7f427a32ed',
    title: 'Bengali New Year',
    caption: 'Pohela Boishakh - Bangladesh\'s colorful New Year celebration with masks and processions',
    region: 'Bangladesh'
  },
  {
    url: 'https://images.unsplash.com/photo-1763733594047-d1ab598fb6f5',
    title: 'Nepali Traditions',
    caption: 'Nepali women in traditional attire at Darchula Mela festival',
    region: 'Nepal'
  },
  // Middle East Culture (Secondary)
  {
    url: 'https://images.unsplash.com/photo-1674978679435-3c3050600ea8',
    title: 'UAE Mosque Interior',
    caption: 'Sheikh Zayed Mosque chandeliers - Emirati hospitality and Islamic artistic grandeur',
    region: 'UAE'
  },
  {
    url: 'https://images.unsplash.com/photo-1678038592321-7893395b1004',
    title: 'Egyptian Traditions',
    caption: 'Contemporary Egyptian culture blending ancient traditions with modern lifestyle',
    region: 'Egypt'
  },
  {
    url: 'https://images.unsplash.com/photo-1730366587880-55998e80a870',
    title: 'Saudi Heritage',
    caption: 'Saudi Arabia\'s historic fortresses and mosques - rich Islamic heritage',
    region: 'Saudi Arabia'
  },
  {
    url: 'https://images.unsplash.com/photo-1717518215150-dbee9416a940',
    title: 'Jordanian Heritage',
    caption: 'Jordan\'s preserved ruins representing rich Greco-Roman cultural crossroads',
    region: 'Jordan'
  },
  {
    url: 'https://images.unsplash.com/photo-1769093173089-ef6cd962527b',
    title: 'Bedouin Traditions',
    caption: 'Traditional Bedouin gathering - ancient nomadic culture of the Arabian desert',
    region: 'Middle East'
  },
  {
    url: 'https://images.unsplash.com/photo-1760976120656-495b25b9821a',
    title: 'Islamic Art',
    caption: 'Ornate Islamic tilework - geometric patterns representing mathematical precision in art',
    region: 'Middle East'
  },
  // Additional Global
  {
    url: 'https://images.unsplash.com/photo-1767330855102-528b112b7b07',
    title: 'Bengali Festival',
    caption: 'Vibrant festival celebration with large masks and traditional decorations',
    region: 'Bangladesh'
  },
  {
    url: 'https://images.unsplash.com/photo-1760638260677-3fbd7f49e1e2',
    title: 'Asian Mask Dance',
    caption: 'Traditional mask performance representing spiritual traditions across Asia',
    region: 'Asia'
  },
  {
    url: 'https://images.unsplash.com/photo-1565689477474-36ff3b63ac6c',
    title: 'Camel Heritage',
    caption: 'Traditional camel riding - symbol of Bedouin culture and desert survival',
    region: 'Middle East'
  },
  {
    url: 'https://images.unsplash.com/photo-1567978010917-bf1f98aa2a95',
    title: 'Mosque Architecture',
    caption: 'Stunning white and gold mosque interiors - Islamic architectural excellence',
    region: 'UAE'
  }
];

const HomeModern = () => {
  const [activeTab, setActiveTab] = useState(null);
  const tabSectionRef = useRef(null);
  const location = useLocation();

  // Handle navigation state from HeaderModern
  useEffect(() => {
    if (location.state?.activeTab) {
      const tabName = location.state.activeTab;
      setActiveTab(tabName);
      setTimeout(() => {
        tabSectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 500);
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  const scrollToTabs = (tabName) => {
    setActiveTab(tabName);
    setTimeout(() => {
      tabSectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  };

  const getCurrentGallery = () => {
    switch (activeTab) {
      case 'arts':
        return artsGalleryData;
      case 'films':
        return filmsGalleryData;
      case 'culture':
        return cultureGalleryData;
      default:
        return [];
    }
  };

  // Background images for hero - prioritizing global diversity
  const heroBackgrounds = [
    artsGalleryData[0]?.url, // USA - Statue of Liberty
    artsGalleryData[9]?.url, // India - Taj Mahal
    artsGalleryData[3]?.url, // France - Eiffel Tower
    artsGalleryData[11]?.url, // Singapore
    cultureGalleryData[14]?.url, // Japan - Tea Ceremony
    artsGalleryData[12]?.url  // Indonesia - Borobudur
  ];

  return (
    <div className="home-modern" data-testid="home-page">
      {/* Hero Section */}
      <section style={{ 
        position: 'relative',
        minHeight: '92vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        background: '#FFFFFF'
      }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 1
        }}>
          {heroBackgrounds.map((imageUrl, index) => (
            <div
              key={index}
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundImage: `url(${imageUrl})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                opacity: index === 0 ? 0.15 : 0,
                transition: 'opacity 2s ease-in-out',
                animation: `fadeImage 36s infinite`,
                animationDelay: `${index * 6}s`
              }}
            />
          ))}
        </div>

        <div className="cultural-hero-content" style={{ 
          position: 'relative', 
          zIndex: 10,
          maxWidth: '1000px',
          padding: '80px 24px'
        }}>
          <h1 className="cultural-hero-title" style={{
            animation: 'heroTitleFade 1s ease-out'
          }}>
            Welcome to Project Soft Power
          </h1>
          <p className="cultural-hero-subtitle" style={{
            animation: 'heroSubtitleSlide 1s ease-out 0.3s both'
          }}>
            An International Independent Organization leveraging arts, films, culture, and creative expression as strategic soft power—strengthening national identity, cultural influence, and international collaboration.
          </p>
          <p className="cultural-hero-founder" style={{
            animation: 'heroFounderFade 1s ease-out 0.6s both'
          }}>
            Founded by Leander Lee Marty
          </p>
          <div style={{ 
            marginTop: '40px', 
            display: 'flex', 
            gap: '16px', 
            justifyContent: 'center', 
            flexWrap: 'wrap',
            animation: 'heroBtnsFade 1s ease-out 0.9s both'
          }}>
            <Link to="/about" className="cultural-cta hero-btn-pulse" data-testid="hero-discover-btn">
              Discover Our Mission
            </Link>
            <Link to="/contact" data-testid="hero-contact-btn" style={{ 
              padding: '10px 24px',
              background: 'transparent',
              color: 'var(--text-primary)',
              border: '1px solid var(--surface-dark)',
              borderRadius: '4px',
              textDecoration: 'none',
              fontSize: '14px',
              fontWeight: '500',
              display: 'inline-block'
            }}>
              Get Involved
            </Link>
          </div>
        </div>

        <style>{`
          @keyframes fadeImage {
            0%, 16.67% { opacity: 0.15; }
            33.33%, 83.33% { opacity: 0; }
            100% { opacity: 0; }
          }
          @keyframes heroTitleFade {
            0% { opacity: 0; transform: translateY(-30px); }
            100% { opacity: 1; transform: translateY(0); }
          }
          @keyframes heroSubtitleSlide {
            0% { opacity: 0; transform: translateY(20px); }
            100% { opacity: 1; transform: translateY(0); }
          }
          @keyframes heroFounderFade {
            0% { opacity: 0; }
            100% { opacity: 1; }
          }
          @keyframes heroBtnsFade {
            0% { opacity: 0; transform: scale(0.9); }
            100% { opacity: 1; transform: scale(1); }
          }
          .hero-btn-pulse:hover {
            animation: btnPulse 0.5s ease-out;
          }
          @keyframes btnPulse {
            0% { transform: scale(1); }
            50% { transform: scale(1.05); }
            100% { transform: scale(1); }
          }
        `}</style>
      </section>

      {/* Mission Statement */}
      <section className="cultural-mission">
        <div className="cultural-mission-content">
          <h2 className="cultural-mission-title">
            Uniting the World Through Arts, Films, and Culture
          </h2>
          <p className="cultural-mission-text">
            Project Soft Power works with governments and world leaders to strengthen positive 
            national identity through constructive expression. We breathe and live on the core 
            values of the United Nations, acting as an inspirational wing that unites the world 
            under one roof.
          </p>
          <p className="cultural-mission-text">
            Our work actively advances UN Sustainable Development Goals (SDGs) through creative 
            means—initiatives that promote cultural diplomacy, international cooperation, and unity.
          </p>
          <div className="cultural-tagline">
            <div>One world.</div>
            <div>Many nations.</div>
            <div>One shared responsibility.</div>
          </div>
        </div>
      </section>

      {/* Interactive Tabs Section */}
      <section ref={tabSectionRef} style={{ 
        background: 'var(--primary-white)',
        padding: '80px 24px'
      }} id="explore-tabs">
        <div style={{ maxWidth: '1440px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '48px' }}>
            <h2 className="cultural-section-title">Explore Our Collections</h2>
            <p className="cultural-section-description" style={{ marginTop: '12px' }}>
              Discover arts, films, and cultural heritage from 127 partner nations
            </p>
          </div>

          {/* Three Large Clickable Tabs */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '24px',
            marginBottom: '48px'
          }}>
            {/* Arts Tab */}
            <div
              onClick={() => scrollToTabs('arts')}
              data-testid="arts-tab"
              style={{
                position: 'relative',
                height: '400px',
                borderRadius: '12px',
                overflow: 'hidden',
                cursor: 'pointer',
                border: activeTab === 'arts' ? '3px solid var(--accent-blue)' : '1px solid var(--surface-dark)',
                transition: 'all 0.3s ease'
              }}
            >
              <img 
                src={artsGalleryData[6]?.url} // Michelangelo's David
                alt="Arts Collection"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  transition: 'transform 0.4s ease'
                }}
              />
              <div style={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                right: 0,
                padding: '32px',
                background: 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, transparent 100%)',
                color: 'var(--primary-white)'
              }}>
                <h3 style={{
                  fontFamily: 'var(--font-primary)',
                  fontSize: '28px',
                  fontWeight: '500',
                  marginBottom: '8px'
                }}>Arts</h3>
                <p style={{ fontSize: '14px', opacity: 0.9 }}>
                  Paintings, architecture, sculpture & more
                </p>
              </div>
              {activeTab === 'arts' && (
                <div style={{
                  position: 'absolute',
                  top: '16px',
                  right: '16px',
                  background: 'var(--accent-blue)',
                  color: 'white',
                  padding: '8px 16px',
                  borderRadius: '20px',
                  fontSize: '12px',
                  fontWeight: '500'
                }}>
                  VIEWING
                </div>
              )}
            </div>

            {/* Films Tab */}
            <div
              onClick={() => scrollToTabs('films')}
              data-testid="films-tab"
              style={{
                position: 'relative',
                height: '400px',
                borderRadius: '12px',
                overflow: 'hidden',
                cursor: 'pointer',
                border: activeTab === 'films' ? '3px solid var(--accent-blue)' : '1px solid var(--surface-dark)',
                transition: 'all 0.3s ease'
              }}
            >
              <img 
                src={filmsGalleryData[1]?.url} // Hollywood Sign
                alt="Films Collection"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  transition: 'transform 0.4s ease'
                }}
              />
              <div style={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                right: 0,
                padding: '32px',
                background: 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, transparent 100%)',
                color: 'var(--primary-white)'
              }}>
                <h3 style={{
                  fontFamily: 'var(--font-primary)',
                  fontSize: '28px',
                  fontWeight: '500',
                  marginBottom: '8px'
                }}>Films</h3>
                <p style={{ fontSize: '14px', opacity: 0.9 }}>
                  Global cinema & international co-productions
                </p>
              </div>
              {activeTab === 'films' && (
                <div style={{
                  position: 'absolute',
                  top: '16px',
                  right: '16px',
                  background: 'var(--accent-blue)',
                  color: 'white',
                  padding: '8px 16px',
                  borderRadius: '20px',
                  fontSize: '12px',
                  fontWeight: '500'
                }}>
                  VIEWING
                </div>
              )}
            </div>

            {/* Culture Tab */}
            <div
              onClick={() => scrollToTabs('culture')}
              data-testid="culture-tab"
              style={{
                position: 'relative',
                height: '400px',
                borderRadius: '12px',
                overflow: 'hidden',
                cursor: 'pointer',
                border: activeTab === 'culture' ? '3px solid var(--accent-blue)' : '1px solid var(--surface-dark)',
                transition: 'all 0.3s ease'
              }}
            >
              <img 
                src={cultureGalleryData[3]?.url} // Brazilian Carnival
                alt="Culture Collection"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  transition: 'transform 0.4s ease'
                }}
              />
              <div style={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                right: 0,
                padding: '32px',
                background: 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, transparent 100%)',
                color: 'var(--primary-white)'
              }}>
                <h3 style={{
                  fontFamily: 'var(--font-primary)',
                  fontSize: '28px',
                  fontWeight: '500',
                  marginBottom: '8px'
                }}>Culture</h3>
                <p style={{ fontSize: '14px', opacity: 0.9 }}>
                  Festivals, traditions & heritage from every continent
                </p>
              </div>
              {activeTab === 'culture' && (
                <div style={{
                  position: 'absolute',
                  top: '16px',
                  right: '16px',
                  background: 'var(--accent-blue)',
                  color: 'white',
                  padding: '8px 16px',
                  borderRadius: '20px',
                  fontSize: '12px',
                  fontWeight: '500'
                }}>
                  VIEWING
                </div>
              )}
            </div>
          </div>

          {/* Gallery Display Area */}
          {activeTab && (
            <div data-testid={`${activeTab}-gallery`} style={{
              background: '#FFFFFF',
              borderRadius: '8px',
              padding: '40px',
              marginTop: '32px',
              border: '1px solid #DADCE0'
            }}>
              <div style={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center',
                marginBottom: '32px'
              }}>
                <h3 style={{
                  fontFamily: 'Google Sans, Roboto, sans-serif',
                  fontSize: '24px',
                  fontWeight: '400',
                  textTransform: 'capitalize',
                  color: '#202124'
                }}>
                  {activeTab} Collection ({getCurrentGallery().length} items)
                </h3>
                <button 
                  onClick={() => setActiveTab(null)}
                  style={{
                    background: 'none',
                    border: '1px solid #DADCE0',
                    padding: '8px 16px',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    color: '#5F6368'
                  }}
                >
                  Close Gallery
                </button>
              </div>

              <div className="cultural-grid">
                {getCurrentGallery().map((item, index) => (
                  <div 
                    key={index} 
                    className="cultural-card gallery-card-simple"
                    data-testid={`gallery-item-${index}`}
                    style={{
                      animation: `simpleFadeIn 0.4s ease-out ${index * 0.05}s both`
                    }}
                  >
                    <img 
                      src={item.url} 
                      alt={item.title} 
                      className="cultural-card-image"
                      style={{ height: '220px' }}
                    />
                    <div className="cultural-card-content">
                      <div className="cultural-card-meta" style={{ color: '#5F6368' }}>{item.region}</div>
                      <h4 className="cultural-card-title" style={{ fontSize: '16px', color: '#202124' }}>
                        {item.title}
                      </h4>
                      <p className="cultural-card-description" style={{ fontSize: '13px', color: '#5F6368' }}>
                        {item.caption}
                      </p>
                    </div>
                  </div>
                ))}
              </div>

              <div style={{ textAlign: 'center', marginTop: '40px' }}>
                <Link 
                  to={`/${activeTab}`} 
                  className="cultural-cta"
                  data-testid={`view-all-${activeTab}-btn`}
                  style={{
                    background: '#1A73E8'
                  }}
                >
                  View Full {activeTab.charAt(0).toUpperCase() + activeTab.slice(1)} Collection
                </Link>
              </div>
            </div>
          )}
          
          {/* Simple Google Arts & Culture style animations */}
          <style>{`
            @keyframes simpleFadeIn {
              from { opacity: 0; transform: translateY(20px); }
              to { opacity: 1; transform: translateY(0); }
            }
            .gallery-card-simple {
              transition: box-shadow 0.3s ease, transform 0.3s ease;
            }
            .gallery-card-simple:hover {
              transform: translateY(-4px);
              box-shadow: 0 8px 24px rgba(0,0,0,0.12);
            }
          `}</style>
        </div>
      </section>

      {/* Impact Stats */}
      <section style={{ background: '#F8F9FA' }}>
        <div className="cultural-stats">
          <div className="cultural-stat-item">
            <span className="cultural-stat-number">127</span>
            <span className="cultural-stat-label">Partner Nations</span>
          </div>
          <div className="cultural-stat-item">
            <span className="cultural-stat-number">570+</span>
            <span className="cultural-stat-label">Cultural Projects</span>
          </div>
          <div className="cultural-stat-item">
            <span className="cultural-stat-number">60+</span>
            <span className="cultural-stat-label">Film Co-Productions</span>
          </div>
          <div className="cultural-stat-item">
            <span className="cultural-stat-number">15M+</span>
            <span className="cultural-stat-label">Lives Impacted</span>
          </div>
        </div>
      </section>

      {/* Featured Articles - White Clickable Boxes */}
      <section style={{ 
        background: '#FFFFFF',
        padding: '80px 24px'
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h2 style={{
            fontFamily: 'Google Sans, Roboto, sans-serif',
            fontSize: 'clamp(28px, 4vw, 40px)',
            fontWeight: '400',
            color: '#202124',
            textAlign: 'center',
            marginBottom: '48px'
          }}>
            Discover More
          </h2>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
            gap: '24px'
          }}>
            {/* What is Soft Power Box */}
            <Link 
              to="/what-is-soft-power" 
              data-testid="what-is-soft-power-link"
              style={{
                display: 'block',
                background: '#FFFFFF',
                borderRadius: '8px',
                padding: '48px 32px',
                textDecoration: 'none',
                border: '1px solid #DADCE0',
                transition: 'all 0.3s ease',
                textAlign: 'center'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.12)';
                e.currentTarget.style.transform = 'translateY(-4px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = 'none';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <h3 style={{
                fontFamily: 'Google Sans, Roboto, sans-serif',
                fontSize: '24px',
                fontWeight: '400',
                color: '#202124',
                marginBottom: '12px'
              }}>
                What is Soft Power?
              </h3>
              <p style={{
                fontFamily: 'Roboto, sans-serif',
                fontSize: '14px',
                color: '#5F6368',
                margin: 0
              }}>
                Understanding the strength of cultural influence
              </p>
            </Link>

            {/* One Shared Responsibility Box */}
            <Link 
              to="/one-shared-responsibility" 
              data-testid="one-shared-responsibility-link"
              style={{
                display: 'block',
                background: '#FFFFFF',
                borderRadius: '8px',
                padding: '48px 32px',
                textDecoration: 'none',
                border: '1px solid #DADCE0',
                transition: 'all 0.3s ease',
                textAlign: 'center'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.12)';
                e.currentTarget.style.transform = 'translateY(-4px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = 'none';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <h3 style={{
                fontFamily: 'Google Sans, Roboto, sans-serif',
                fontSize: '24px',
                fontWeight: '400',
                color: '#202124',
                marginBottom: '12px'
              }}>
                One Shared Responsibility
              </h3>
              <p style={{
                fontFamily: 'Roboto, sans-serif',
                fontSize: '14px',
                color: '#5F6368',
                margin: 0
              }}>
                A global people's movement for positive representation
              </p>
            </Link>

            {/* Arts, Films & Culture Box */}
            <Link 
              to="/arts-films-culture" 
              data-testid="arts-films-culture-link"
              style={{
                display: 'block',
                background: '#FFFFFF',
                borderRadius: '8px',
                padding: '48px 32px',
                textDecoration: 'none',
                border: '1px solid #DADCE0',
                transition: 'all 0.3s ease',
                textAlign: 'center'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.12)';
                e.currentTarget.style.transform = 'translateY(-4px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = 'none';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <h3 style={{
                fontFamily: 'Google Sans, Roboto, sans-serif',
                fontSize: '24px',
                fontWeight: '400',
                color: '#202124',
                marginBottom: '12px'
              }}>
                Arts, Films & Culture
              </h3>
              <p style={{
                fontFamily: 'Roboto, sans-serif',
                fontSize: '14px',
                color: '#5F6368',
                margin: 0
              }}>
                The roots and living identity of every nation
              </p>
            </Link>
          </div>
        </div>
      </section>

      {/* Submit Artwork CTA */}
      <section style={{
        background: '#F8F9FA',
        padding: '80px 24px',
        textAlign: 'center'
      }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <h2 style={{
            fontFamily: 'Google Sans, Roboto, sans-serif',
            fontSize: 'clamp(28px, 4vw, 40px)',
            fontWeight: '400',
            color: '#202124',
            marginBottom: '20px'
          }}>
            Share Your Creative Voice
          </h2>
          <p style={{
            fontFamily: 'Roboto, sans-serif',
            fontSize: '16px',
            color: '#5F6368',
            marginBottom: '32px'
          }}>
            Submit your artwork, films, or cultural projects to be featured in our global exhibition
          </p>
          <Link 
            to="/submissions"
            data-testid="submit-artwork-cta"
            style={{
              display: 'inline-block',
              padding: '14px 32px',
              background: '#1A73E8',
              color: '#FFFFFF',
              borderRadius: '4px',
              textDecoration: 'none',
              fontSize: '14px',
              fontWeight: '500'
            }}
          >
            Submit Artwork
          </Link>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{ 
        background: '#202124', 
        padding: '80px 24px',
        textAlign: 'center'
      }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <h2 style={{
            fontFamily: 'Google Sans, Roboto, sans-serif',
            fontSize: 'clamp(28px, 4vw, 40px)',
            fontWeight: '400',
            color: '#FFFFFF',
            marginBottom: '20px'
          }}>
            Join the Global Cultural Movement
          </h2>
          <p style={{
            fontFamily: 'Roboto, sans-serif',
            fontSize: '16px',
            color: 'rgba(255,255,255,0.7)',
            marginBottom: '32px',
            lineHeight: '1.7'
          }}>
            Partner with us to build bridges between cultures, preserve heritage, and create 
            a more peaceful world through arts and cinema.
          </p>
          <Link 
            to="/contact" 
            data-testid="cta-partner-btn"
            style={{
              display: 'inline-block',
              padding: '14px 32px',
              background: '#FFFFFF',
              color: '#202124',
              borderRadius: '4px',
              textDecoration: 'none',
              fontSize: '14px',
              fontWeight: '500'
            }}
          >
            Partner With Us
          </Link>
        </div>
      </section>
    </div>
  );
};

export default HomeModern;
